import React, { useState } from 'react';
import { auth } from '../firebase';
import config from '../config';
import './AffiliateModal.css';

const AffiliateModal = ({ userId, onClose }) => {
  const [selectedAffiliate, setSelectedAffiliate] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState('');
  const API_BASE_URL = config.backendUrl;

  const affiliateOptions = [
    { id: '', name: 'Please select...' },
    { id: 'builder_brigade', name: 'Builder Brigade' },
    { id: 'monster_house_plans', name: 'Monster House Plans' },
    { id: 'barndominium_company', name: 'The Barndominium Company' },
    { id: 'other', name: 'Other' }
  ];

  const handleAffiliateSelect = (e) => {
    setSelectedAffiliate(e.target.value);
  };

  // Handle modal dismissal without submitting
  const handleDismiss = () => {
    // Mark that we've shown the affiliate modal in this session
    sessionStorage.setItem('hasShownAffiliateModal', 'true');
    onClose(false); // Pass false to indicate no tracking was done
  };

  // Submit handler that ensures API call completes before closing
  const handleSubmit = () => {
    // Validate selection
    if (!selectedAffiliate) {
      setError('Please select an option');
      return;
    }

    // Set submitting state
    setIsSubmitting(true);
    setError('');
    
    // Get current user
    const currentUser = auth.currentUser;
    if (!currentUser) {
      console.error('User not authenticated');
      sessionStorage.setItem('hasShownAffiliateModal', 'true');
      onClose(false);
      return;
    }
    
    // Get token and make API call
    currentUser.getIdToken().then(firebaseToken => {
      // Make API call and wait for it to complete
      fetch(`${API_BASE_URL}/affiliate/track`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${firebaseToken}`
        },
        body: JSON.stringify({
          playerId: userId,
          affiliateId: selectedAffiliate
        })
      })
      .then(response => {
        if (!response.ok) {
          return response.json().then(data => {
            throw new Error(data.error || 'Failed to track affiliate');
          });
        }
        return response.json();
      })
      .then(() => {
        console.log('Affiliate tracking successful');
        // Mark that we've shown the affiliate modal in this session
        sessionStorage.setItem('hasShownAffiliateModal', 'true');
        // Close the modal with success flag
        onClose(true);
      })
      .catch(err => {
        console.error('Error tracking affiliate:', err);
        // Mark that we've shown the affiliate modal in this session
        sessionStorage.setItem('hasShownAffiliateModal', 'true');
        // Still close the modal, but indicate there was an error
        onClose(false);
      })
      .finally(() => {
        setIsSubmitting(false);
      });
    })
    .catch(err => {
      console.error('Error getting token:', err);
      setIsSubmitting(false);
      onClose(false);
    });
  };

  return (
    <div className="affiliate-modal-overlay" onClick={handleDismiss}>
      <div className="affiliate-modal" onClick={e => e.stopPropagation()}>
        <div className="affiliate-modal-header">
          <h2>Welcome to dream book!</h2>
        </div>
        
        <div className="affiliate-modal-content">
          <p>Where did you hear about us?</p>
          
          <div className="affiliate-select-container">
            <select
              value={selectedAffiliate}
              onChange={handleAffiliateSelect}
              className="affiliate-select"
              aria-label="Select where you heard about us"
            >
              {affiliateOptions.map((option) => (
                <option key={option.id} value={option.id}>
                  {option.name}
                </option>
              ))}
            </select>
          </div>
          
          {error && <div className="affiliate-error">{error}</div>}
        </div>
        
        <div className="affiliate-modal-footer">
          <button 
            className="affiliate-continue-button"
            onClick={handleSubmit}
            disabled={isSubmitting}
          >
            {isSubmitting ? 'Please wait...' : 'Continue'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default AffiliateModal;
